var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 149.865,
    height: 26.207,
    viewBox: "0 0 149.865 26.207",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.5,
    x2: 1,
    y2: 0.738,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffa741"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff7541"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_177454",
    "data-name": "Path 177454",
    d: "M1.228.886a3.049,3.049,0,0,0,0,4.3l.2.2L8.142,12.1,10.25,9.989a3.091,3.091,0,0,0,.242-4.149L5.527.886a3.049,3.049,0,0,0-4.3,0",
    transform: "translate(-0.342)",
    stroke: "rgba(0,0,0,0)",
    strokeWidth: 1,
    fill: "url(#linear-gradient)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_177455",
    "data-name": "Path 177455",
    d: "M10.963,28.926,7.456,32.435h0L.89,39a3.039,3.039,0,0,0,4.3,4.3L15.3,33.18a3.039,3.039,0,0,0,0-4.3c-.061-.061-.125-.117-.19-.172s-.11-.128-.17-.188L12.1,25.671a3.887,3.887,0,0,1-1.14,3.255",
    transform: "translate(0 -25.671)",
    stroke: "rgba(0,0,0,0)",
    strokeWidth: 1,
    fill: "url(#linear-gradient)"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_30857",
    "data-name": "Group 30857",
    transform: "translate(18786.254 12811.207)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_29747",
    "data-name": "Group 29747",
    transform: "translate(-18786.254 -12811.207)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_29741",
    "data-name": "Group 29741",
    transform: "translate(0.102)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_29740",
    "data-name": "Group 29740",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7264",
    "data-name": "Rectangle 7264",
    width: 16.641,
    height: 16.641,
    transform: "translate(-6.345 6.049) rotate(-45)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_7264_-_Outline",
    "data-name": "Rectangle 7264 - Outline",
    d: "M0,0H17.462V17.462H0ZM16.641.821H.821v15.82h15.82Z",
    transform: "translate(-6.925 6.049) rotate(-45)",
    fill: "rgba(0,0,0,0)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_29743",
    "data-name": "Group 29743",
    transform: "translate(0 7.693)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_29742",
    "data-name": "Group 29742",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7265",
    "data-name": "Rectangle 7265",
    width: 16.788,
    height: 18.811,
    transform: "translate(-0.297 0)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_7265_-_Outline",
    "data-name": "Rectangle 7265 - Outline",
    d: "M-.5-.5H17.109V19.132H-.5ZM16.288.321H.321v17.99H16.288Z",
    transform: "translate(-0.207 0.089)",
    fill: "rgba(0,0,0,0)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_30857-2",
    "data-name": "Group 30857",
    transform: "translate(-18759.27 -12804.256)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_177456",
    "data-name": "Path 177456",
    d: "M122.325,23.722H124.4a2.649,2.649,0,0,1,1.918.614,3.31,3.31,0,0,1,.8,2.432,4.167,4.167,0,0,1-.421,2.02,1.8,1.8,0,0,1-1.2.943l2.153,5.692h-1.6l-2.145-5.73v5.73h-1.577Zm1.577,5.184a1.671,1.671,0,0,0,1.3-.425,2.143,2.143,0,0,0,.379-1.432,4.694,4.694,0,0,0-.079-.932,1.663,1.663,0,0,0-.251-.629,1,1,0,0,0-.44-.357,1.643,1.643,0,0,0-.64-.113H123.9Z",
    transform: "translate(-112.653 -23.563)",
    fill: "#132c4a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_177457",
    "data-name": "Path 177457",
    d: "M157.232,23.721h1.228l2.508,11.7h-1.561l-.44-2.281h-2.319l-.447,2.281h-1.515Zm1.508,8.2-.349-1.864q-.349-1.9-.568-4.062-.107,1.052-.273,2.132t-.394,2.292l-.288,1.5Z",
    transform: "translate(-135.318 -23.563)",
    fill: "#132c4a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_177458",
    "data-name": "Path 177458",
    d: "M188.21,23.722h1.553l.705,4.32.12.781.251,1.7q.059.432.109.788t.087.644l.076.577c.015-.117.028-.22.038-.311s.021-.167.031-.228l.2-1.356.265-1.781c.025-.162.05-.311.072-.448s.044-.257.064-.363l.758-4.32h1.471l-2.3,11.7h-1.25Z",
    transform: "translate(-158.795 -23.563)",
    fill: "#132c4a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_177459",
    "data-name": "Path 177459",
    d: "M223.933,23.722h4.191v1.334h-2.615v3.706h2.319V30.1h-2.319v3.994h2.615v1.334h-4.191Z",
    transform: "translate(-183.813 -23.563)",
    fill: "#132c4a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_177460",
    "data-name": "Path 177460",
    d: "M256.216,23.722h1.577V34.089h2.577v1.334h-4.154Z",
    transform: "translate(-206.422 -23.563)",
    fill: "#132c4a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_177461",
    "data-name": "Path 177461",
    d: "M286.83,23.722h1.577V34.089h2.577v1.334H286.83Z",
    transform: "translate(-227.863 -23.563)",
    fill: "#132c4a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_177462",
    "data-name": "Path 177462",
    d: "M317.446,23.722h4.191v1.334h-2.615v3.706h2.32V30.1h-2.32v3.994h2.615v1.334h-4.191Z",
    transform: "translate(-249.305 -23.563)",
    fill: "#132c4a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_177463",
    "data-name": "Path 177463",
    d: "M349.731,23.722h2.077a2.648,2.648,0,0,1,1.917.614,3.31,3.31,0,0,1,.8,2.432,4.178,4.178,0,0,1-.42,2.02,1.806,1.806,0,0,1-1.2.943l2.153,5.692h-1.6l-2.145-5.73v5.73h-1.577Zm1.577,5.184a1.671,1.671,0,0,0,1.3-.425,2.143,2.143,0,0,0,.378-1.432,4.65,4.65,0,0,0-.079-.932,1.667,1.667,0,0,0-.25-.629,1.009,1.009,0,0,0-.44-.357,1.644,1.644,0,0,0-.641-.113h-.265Z",
    transform: "translate(-271.914 -23.563)",
    fill: "#132c4a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_177464",
    "data-name": "Path 177464",
    d: "M385.025,23.722H387.1a2.8,2.8,0,0,1,2.182.758,3.584,3.584,0,0,1,.682,2.425q0,2.334-1.372,3.016a5.007,5.007,0,0,1-1.993.311v5.191h-1.577Zm1.577,5.162a1.822,1.822,0,0,0,1.349-.395,2.073,2.073,0,0,0,.379-1.424,2.571,2.571,0,0,0-.363-1.532,1.34,1.34,0,0,0-1.145-.485h-.22Z",
    transform: "translate(-296.632 -23.563)",
    fill: "#132c4a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_177465",
    "data-name": "Path 177465",
    d: "M417.454,23.721h1.227l2.508,11.7h-1.561l-.44-2.281H416.87l-.448,2.281h-1.515Zm1.508,8.2-.349-1.864q-.349-1.9-.569-4.062-.105,1.052-.272,2.132t-.394,2.292l-.288,1.5Z",
    transform: "translate(-317.559 -23.563)",
    fill: "#132c4a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_177466",
    "data-name": "Path 177466",
    d: "M455.514,23.595v1.539a2.313,2.313,0,0,0-1.3-.515,1.3,1.3,0,0,0-1.016.44,1.553,1.553,0,0,0-.394,1.114,1.92,1.92,0,0,0,.28,1.052,4.593,4.593,0,0,0,.474.607q.329.373.853.894a7.028,7.028,0,0,1,1.311,1.691,3.717,3.717,0,0,1,.348,1.69,3.28,3.28,0,0,1-.766,2.236,2.512,2.512,0,0,1-1.962.856,2.723,2.723,0,0,1-1.721-.553V33.084a2.684,2.684,0,0,0,1.531.614,1.25,1.25,0,0,0,1.008-.428,1.738,1.738,0,0,0,.364-1.163,2.331,2.331,0,0,0-.28-1.145,4.772,4.772,0,0,0-.4-.558q-.258-.314-.644-.7-.6-.59-.992-1.045a4.878,4.878,0,0,1-.584-.8,3.5,3.5,0,0,1-.363-1.683A3.161,3.161,0,0,1,451.974,24a2.459,2.459,0,0,1,1.933-.81,3.424,3.424,0,0,1,1.607.4",
    transform: "translate(-343.019 -23.194)",
    fill: "#132c4a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_177467",
    "data-name": "Path 177467",
    d: "M488.3,23.595v1.539a2.315,2.315,0,0,0-1.3-.515,1.3,1.3,0,0,0-1.015.44,1.552,1.552,0,0,0-.394,1.114,1.915,1.915,0,0,0,.28,1.052,4.482,4.482,0,0,0,.474.607q.329.373.853.894a6.99,6.99,0,0,1,1.31,1.691,3.708,3.708,0,0,1,.349,1.69,3.28,3.28,0,0,1-.766,2.236,2.512,2.512,0,0,1-1.962.856,2.722,2.722,0,0,1-1.721-.553V33.084a2.682,2.682,0,0,0,1.53.614,1.251,1.251,0,0,0,1.009-.428,1.738,1.738,0,0,0,.364-1.163,2.337,2.337,0,0,0-.28-1.145,4.666,4.666,0,0,0-.4-.558c-.171-.209-.386-.443-.643-.7q-.6-.59-.993-1.045a4.9,4.9,0,0,1-.584-.8,3.487,3.487,0,0,1-.364-1.683A3.161,3.161,0,0,1,484.763,24a2.458,2.458,0,0,1,1.932-.81,3.423,3.423,0,0,1,1.607.4",
    transform: "translate(-365.982 -23.194)",
    fill: "#132c4a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_177468",
    "data-name": "Path 177468",
    d: "M94.2,35.424H92.627V25.056H90.05V23.722H94.2Z",
    transform: "translate(-90.05 -23.563)",
    fill: "#132c4a"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.79973e9d2338cd73bcaabbc8ce7cd0c6.svg";
export { ForwardRef as ReactComponent };